<template>
    <div class="time-out">
        Oh, honey, I got a bit carried away daydreaming! Can you try that again, pretty please?
    </div>
  </template>

<script>
export default {

};
</script>

  <style>
  .time-out {
      display: inline-block;
      border-radius: 12px 12px 12px 0;
      padding: 14px;
      max-width: 240px;
      background-color: #fff;
      font-style: 14px;
      line-height: 17px;
      font-family: Roboto;
      color: rgba(30, 30, 30, 1);
  }
  </style>
